<template>
  <div id="app" :class="{ 'logged-in': userIsLoggedIn }">
    <loader></loader>
    <navbar></navbar>
    <div class="feedback" v-if="user">
      <div
        class="feedback-icon-text black text-secondary-color"
        v-on:click="openModalFeedback"
      >
        <i class="icon-feedback"></i>
      </div>
    </div>
    <modal></modal>
    <router-view></router-view>
  </div>
</template>

<script>
import bus from "./bus";

import Navbar from "@/components/shared/Navbar";
import Loader from "@/components/shared/Loader";
import Modal from "./components/shared/Modal";

export default {
  name: "App",
  components: {
    Navbar,
    Loader,
    Modal,
  },
  methods: {
    openModalFeedback() {
      bus.$emit("open-modal", "FeedbackModal");
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    userIsLoggedIn() {
      if (this.user) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss">
@use 'styles/icons.scss';
@use 'styles/fonts.scss';
@use 'styles/theme.scss';

*,
*::before,
*::after {
  position: inital;
}

#app {
  font-family: theme.$font-family;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: theme.$text-color;
  padding: theme.$page-padding-top theme.$page-padding-small-X
    theme.$page-padding-bottom;
  font-size: 14px;
}

#app h2 {
  font-weight: 900;
  font-size: 24px;
  font-family: theme.$font-family-strong;
}

#app h4 {
  font-size: 14px;
  font-weight: 400;
}

#app .bold {
  font-weight: theme.$font-weight-bold;
}

#app .black {
  font-weight: theme.$font-weight-black;
}

#app .primary-color {
  color: theme.$primary-color;
}

#app .primary-color-dark {
  color: theme.$primary-color-dark;
}

#app .text-secondary-color {
  color: theme.$text-secondary-color;
}

#app .grey-background {
  background: theme.$grey-color;
}

#app .center {
  text-align: center;
}

#app .light-button {
  border-radius: 4px;
  padding: 8px;
  cursor: pointer;
}

#app .light-button:hover {
  background: theme.$secondary-color;
}

#app .icon {
  font-size: 22px;
  color: theme.$primary-color;
}

#app .feedback {
  cursor: pointer;
  z-index: 2;
  position: absolute;
  top: 45px;
  right: theme.$page-padding-X;
  text-align: center;
}

.feedback-icon-text {
  font-size: 14px;
}

#app ul[role="menu"] {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  border: 1px solid theme.$light-grey-background;
  border-radius: 4px;
}

#app ul[role="menu"] a {
  color: theme.$text-color;
  font-weight: theme.$font-weight-bold;
}

@media (min-width: 576) {
  #app {
    padding: theme.$page-padding-top theme.$page-padding-X
      theme.$page-padding-bottom;
  }
}

@media (min-width: 768px) {
  #app.logged-in {
    margin-left: 300px;
  }
  .evaluate,
  .list-evaluate {
    margin-left: 300px;
  }

  #signup ~ .loader-drop .loader,
  #signup ~ .loader-drop .text-loader {
    margin-left: 0;
  }
}
.icon-feedback {
  font-size: 18px;
  color: #bbbbbb;
}
</style>
